'use client';

import { PageShell } from '@/components/PageShell';
import { ShareFallbackPage } from '@/components/ShareFallbackPage';

const DEFAULT_LANGUAGE = 'en';

/** 全局 404 / not-found 兜底（与分享页下线 UI 一致） */
export function GlobalNotFoundPage() {
  return (
    <PageShell language={DEFAULT_LANGUAGE}>
      <ShareFallbackPage language={DEFAULT_LANGUAGE} />
    </PageShell>
  );
}
